/** Travel login modes map 1:1 to formal MemberEnt login contract. */
export const LOGIN_MODE = {
  ACCOUNT: 'account',
  EMAIL: 'email',
  MOBILE: 'mobile',
};

/**
 * Build POST /memberEnt/login body.
 * Account and Email both send { username, password } (backend resolves username then email).
 * Mobile sends { username: mobile, password, countryName }.
 */
export function buildLoginPayload(mode, values) {
  const password = String(values.password || '');
  if (mode === LOGIN_MODE.MOBILE) {
    return {
      username: String(values.mobile || '').trim(),
      password,
      countryName: String(values.countryName || '').trim(),
    };
  }
  if (mode === LOGIN_MODE.EMAIL) {
    return {
      username: String(values.email || '').trim(),
      password,
    };
  }
  return {
    username: String(values.username || '').trim(),
    password,
  };
}

export function rememberKeyForLogin(mode, values) {
  if (mode === LOGIN_MODE.MOBILE) {
    return `mobile:${String(values.countryName || '').trim()}:${String(values.mobile || '').trim()}`;
  }
  if (mode === LOGIN_MODE.EMAIL) {
    return `email:${String(values.email || '').trim()}`;
  }
  return `account:${String(values.username || '').trim()}`;
}

export function parseRememberKey(raw) {
  if (!raw || typeof raw !== 'string') {
    return null;
  }
  if (raw.startsWith('mobile:')) {
    const parts = raw.split(':');
    return {
      mode: LOGIN_MODE.MOBILE,
      countryName: parts[1] || '',
      mobile: parts.slice(2).join(':') || '',
    };
  }
  if (raw.startsWith('email:')) {
    return { mode: LOGIN_MODE.EMAIL, email: raw.slice('email:'.length) };
  }
  if (raw.startsWith('account:')) {
    return { mode: LOGIN_MODE.ACCOUNT, username: raw.slice('account:'.length) };
  }
  // Legacy Exchange email-tab key (plain username/email string)
  return { mode: LOGIN_MODE.ACCOUNT, username: raw };
}
